module.exports = __webpack_public_path__ + "static/media/sx.5a5b47d6.svg";